<!--
 * @Author: Zheng Lei
 * @Email: baimoc@163.com
 * @Date: 2021-03-03 10:49:23
 * @LastEditTime: 2021-06-24 10:10:26
 * @FilePath: \EmAtlas\src\views\Analysis\GenomeAnalysis.vue
-->
<template>
    <div class="baimo-scrollbar bm-none">
        <!--<el-scrollbar style="height: 300px" class="baimo-scrollbar bm">-->
        <div style="height: 30px; color: #2F363D; background: #F6F8FA;">
            <!--<el-dropdown style="padding-top: 0px;">-->
                  <!--<span class="el-dropdown-link" style="font-size: 13px;">-->
                    <!--Selection<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
                  <!--</span>-->
                <!--<el-dropdown-menu slot="dropdown">-->
                    <!--<el-dropdown-item><i class="el-icon-check"></i>Exclusive</el-dropdown-item>-->
                    <!--<el-dropdown-item>Multiple</el-dropdown-item>-->
                    <!--<el-dropdown-item>None</el-dropdown-item>-->
                <!--</el-dropdown-menu>-->
            <!--</el-dropdown>-->
            <!--<el-dropdown style="padding-top: 0px;">-->
                  <!--<span class="el-dropdown-link" style="font-size: 13px;">-->
                    <!--View<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
                  <!--</span>-->
                <!--<el-dropdown-menu slot="dropdown">-->
                    <!--<el-dropdown-item>Modern</el-dropdown-item>-->
                    <!--<el-dropdown-item>Simple</el-dropdown-item>-->
                <!--</el-dropdown-menu>-->
            <!--</el-dropdown>-->
            <!--<el-dropdown style="padding-top: 0px;">-->
                  <!--<span class="el-dropdown-link" style="font-size: 13px;">-->
                    <!--Wrap<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
                  <!--</span>-->
                <!--<el-dropdown-menu slot="dropdown">-->
                    <!--<el-dropdown-item>60</el-dropdown-item>-->
                    <!--<el-dropdown-item>100</el-dropdown-item>-->
                    <!--<el-dropdown-item>None</el-dropdown-item>-->
                    <!--<el-dropdown-item>Auto</el-dropdown-item>-->
                <!--</el-dropdown-menu>-->
            <!--</el-dropdown>-->
            <i class="el-icon-question" style="float: right;font-size: 18px;padding: 5px;"></i>
            <i class="el-icon-download" style="float: right;font-size: 18px;padding: 5px;"></i>
            <i class="el-icon-refresh-left" style="float: right;font-size: 18px;padding: 5px;"></i>
        </div>
        <div id="seq_container" class="baimo-scrollbar"
             :style="{height: height, width: winWidth, background: '#F6F8FA',borderTop: '1px solid #ebeef2'} ">
        </div>
        <!--</el-scrollbar>-->
    </div>
</template>

<script>
    import * as d3 from 'd3';

    export default {
        name: "StructureView",
        data() {
            return {
                winHeight: window.innerHeight - 50 - 300 + "px",
                winWidth: window.innerWidth - 352 + "px",
                loading: false,
                pointer: '',
                protein_seq: '',
                selected: {
                    'start':'',
                    'end':''
                },
                reduce_seq: {
                    "Natural": "MRATPLAAPAGSLSRKKRLELDDNLDTERPVQKRARSGPQPRLPPCLLPLSPPTAPDRATAVATASRLGPYVLLEPEEGGRAYQALHCPTGTEYTCKVYPVQEALAVLEPYARLPPHKHVARPTEVLAGTQLLYAFFTRTHGDMHSLVRSRHRIPEPEAAVLFRQMATALAHCHQHGLVLRDLKLCRFVFADRERKKLVLENLEDSCVLTGPDDSLWDKHACPAYVGPEILSSRASYSGKAADVWSLGVALFTMLAGHYPFQDSEPVL",
                    "Reduced": "LELLLLLLLLLLLLEEEELELEEELELEELLEEELELLLELELLLLLLLLLLLLLLEELLLLLLLLELLLLLLLELEELLELLELLELLLLLELLLELLLLEELLLLLELLLELLLEEELLELLELLLLLELLLLLLLELELELELLLELEEELLELELLLLLEELLLLLLELEEELLLLEELELLELLLLEEEEEELLLEELEELLLLLLLEELLLEEELLLLLLLLELLLLELLLLLELLELLLLLLLLLLLLLLELLLEELELLL",
                },
                raac_color: {
                    "A": "#f3a683",
                    "R": "#f7d794",
                    "N": "#778beb",
                    "D": "#e77f67",
                    "C": "#cf6a87",
                    "Q": "#f19066",
                    "E": "#f5cd79",
                    "G": "#546de5",
                    "H": "#e15f41",
                    "I": "#c44569",
                    "L": "#786fa6",
                    "K": "#f8a5c2",
                    "M": "#63cdda",
                    "F": "#ea8685",
                    "P": "#596275",
                    "S": "#574b90",
                    "T": "#f78fb3",
                    "W": "#3dc1d3",
                    "Y": "#e66767",
                    "V": "#303952"
                },
                natral_color: {},
            }
        },
        mounted() {
            this.init();
        },
        props: {
            params: Object,
            height: String,
            width: String,
        },
        watch:{
            params: {
                handler(params){
                    this.protein_seq = params['source']['sequence'];
                },
                deep: true
            },
            protein_seq(val){
                this.sequence = val;
                this.reduced_seq();
            },
            '$store.state.raac_color'(){
                // console.log(">>>", this.$store.state.raac_color);
                this.get_raac_color();
                this.reduced_seq();
            },
            '$store.state.raac_scheme'(val){
                // console.log(val);
                this.get_raac_color();
                this.reduced_seq();
            }
        },
        methods: {
            get_raac_color(){
                let raac_scheme = this.$store.state.raac_scheme;
                let raac_color = this.$store.state.raac_color;
                let color_map = {};
                raac_scheme.forEach((item, i)=> {
                    let replace_aa = item.substr(0, 1);
                    color_map[replace_aa] = raac_color[i];
                });
                this.raac_color = color_map;
            },
            get_reduced_seq(){
                let raac_scheme = this.$store.state.raac_scheme;
                let natural_seq = this.protein_seq;
                let reduced_seq = "";
                let reduced_map = {};
                // console.log(this.protein_seq);
                // console.log(this.$store.state.raac_scheme);
                raac_scheme.forEach((item)=>{
                   let replace_aa = item.substr(0, 1);
                    for (let i = 0; i < item.length; i++){
                        reduced_map[item[i]] = replace_aa
                    }
                });
                // console.log(reduced_map)
                for (let i = 0; i < natural_seq.length; i++) {
                    reduced_seq += reduced_map[natural_seq[i]];
                }
                let input_seq = {
                    "Natural": natural_seq,
                    "Reduced": reduced_seq
                };
                return input_seq;
            },
            init() {
                this.natral_color = this.raac_color;
                this.reduced_seq(this.reduce_seq);
            },
            reduced_seq() {
                let reduce_seq = this.get_reduced_seq();
                this.render_seq(reduce_seq);
            },
            render_seq(sequence) {
                let natural = sequence['Natural'];
                let reduced = sequence['Reduced'];
                let seq_len = natural.length;
                let params = {
                    global: {
                        width: 'auto',
                        height: 110,
                        padding: [15, 10, 10, 10],
                        background: '#F6F8FA',
                    },
                    aa: {
                        fontSize: 16,
                        padding: [1,0,0,70],
                        backgroundPadding: [0,0,0,62],
                        backgroundRect: [16, 20],
                        offset: [0,14],
                        color: 'white'
                    },
                    midline: {
                        fontSize: 14,
                        background: 'transparent',
                        color: '#718093'
                    },
                    header: {
                        fontSize: 14,
                        backgroundRect: [60, 20],
                        background: 'transparent',
                        color: '#718093',
                        padding: [-5, 0, 0, 0]
                    },
                    ruler: {
                        height: 10,
                        strokeWidth: 2,
                        color: '#718093',
                        padding: [0, 0, 0, 0]
                    },
                    scale: {
                        height: 5,
                        fontSize: 14,
                        color: '#718093',
                        offset: [0,14],
                        interval: 10,
                    }
                };
                reduced;
                document.getElementById("seq_container").innerHTML = "";
                // console.log(seq_len, svg_width, params['aa']['fontSize']);
                this.svg = d3.select("#seq_container")
                    .append("svg")
                    .attr('width', params['header']['backgroundRect'][0] + seq_len * params['aa']['backgroundRect'][0] + params['global']['padding'][1] + params['global']['padding'][3])
                    .attr('height', params['global']['height'])
                    .attr("style", `background-color:${params['global']['background']}`);
                // console.log("render_seq", d3.select("#seq_container"));
                this.add_header("Natural", params, [7, 0]);
                this.add_header("", params, [0, params['header']['backgroundRect'][1]]);
                this.add_header("Reduced", params, [0, params['header']['backgroundRect'][1]*2]);
                this.add_aa(natural, params, [0, 0], this.natral_color);
                this.add_midline(natural, params);
                this.add_aa(reduced, params, [0, params['header']['backgroundRect'][1]*2], this.raac_color);
                this.add_ruler(natural, params);
                // this.add_pointer(0, params);
                this.add_select_layer(natural, params);
                // this.add_selecter(0, params);
            },
            add_pointer(i, params){
                this.pointer = this.svg.append('rect')
                    .attr('width', params['aa']['backgroundRect'][0])
                    .attr('height', 5)
                    .attr('id', "pointer")
                    .attr('x',params['global']['padding'][3] + params['aa']['backgroundPadding'][3] + params['aa']['fontSize'] * i)
                    .attr('y',params['global']['padding'][0] + params['aa']['backgroundPadding'][0] - 5)
                    .attr('text-anchor', 'middle')
                    // .attr('style', 'fill:transparent;')
                    .attr('style', 'fill:red;opacity:0.2')
            },
            add_selecter(i, params){
                this.svg.append('rect')
                    .attr('width', params['aa']['backgroundRect'][0])
                    .attr('height', params['aa']['backgroundRect'][1]*3)
                    .attr('x',params['global']['padding'][3] + params['aa']['backgroundPadding'][3] + params['aa']['fontSize'] * i)
                    .attr('y',params['global']['padding'][0] + params['aa']['backgroundPadding'][0])
                    .attr('text-anchor', 'middle')
                    // .attr('style', 'fill:transparent;')
                    .attr('style', 'fill:red;opacity:0.2')
                    // .on("click", function(env) {
                    //     console.log(env)
                    //     d3.select(this).attr("style","fill:green;stroke-width:2;stroke:#ee5253;stroke-opacity:0.8;opacity:0.8");
                    // })
            },
            add_select_layer(seq, params){
                let selecter_g = this.svg.append("g").attr('id', 'selecter');
                let current_x = 0;
                let selected = this.selected;
                let vue_obj = this;
                for (let i = 0; i < seq.length; i++) {
                    let aa = seq[i];
                    var flag = 0;
                    this.svg.append('rect')
                        .attr('width', params['aa']['backgroundRect'][0])
                        .attr('height', params['aa']['backgroundRect'][1] * 3 + params['global']['padding'][0] + params['aa']['backgroundPadding'][0] + params['ruler']['height'] + params['scale']['height']*2)
                        .attr('x', params['global']['padding'][3] + params['aa']['backgroundPadding'][3] + params['aa']['fontSize'] * i)
                        .attr('y', 0)
                        .attr('text-anchor', 'middle')
                        .attr('style', 'fill:transparent;')
                        .attr('id', aa)
                        .attr('num', i)

                        .on("mousedown",function(){
                            flag = 1;
                            let x = d3.select(this).attr("x");
                            selecter_g.remove();
                            selecter_g = vue_obj.svg.append("g").attr('id', 'selecter');
                            selecter_g.append('rect')
                                .attr('width', params['aa']['backgroundRect'][0])
                                .attr('height', 5)
                                .attr('id', "pointer")
                                .attr('x',x)
                                .attr('y',params['global']['padding'][0] + params['aa']['backgroundPadding'][0] - 5)
                                .attr('text-anchor', 'middle')
                                .attr('style', 'fill:red;');
                            selected['start'] = d3.select(this).attr("num");
                        })
                        .on("mouseover",function(){
                            let x = d3.select(this).attr("x");
                            d3.select(this).attr("style", "fill:rgba(84, 160, 255,0.4);");
                            if(flag) {
                                selecter_g.append('rect')
                                    .attr('width', params['aa']['backgroundRect'][0])
                                    .attr('height', 5)
                                    .attr('id', "pointer")
                                    .attr('x',x)
                                    .attr('y',params['global']['padding'][0] + params['aa']['backgroundPadding'][0] - 5)
                                    .attr('text-anchor', 'middle')
                                    // .attr('style', 'fill:transparent;')
                                    .attr('style', 'fill:red;')
                            }
                        })
                        .on("mouseout", function(){
                            if(current_x != d3.select(this).attr("x")){
                                d3.select(this).attr("style", "fill:transparent;");
                            }
                        })
                        .on("mouseup",function(){
                            flag = 0;
                            selected['end'] = d3.select(this).attr("num");
                            // console.log(selected)
                            vue_obj.$emit('selectedRange', selected);
                        });
                }
            },
            changeColor(evt) {
                // console.log(evt)
                // let target = evt.target;
                // target.setAttributeNS(null, "fill", "blue");
            },
            add_header(text, params, offset){
                this.svg.append('rect')
                    .attr('width', params['header']['backgroundRect'][0])
                    .attr('height', params['header']['backgroundRect'][1])
                    .attr('x', params['global']['padding'][3] + offset[0])
                    .attr('y', params['global']['padding'][0] + offset[1])
                    .attr('text-anchor', 'middle')
                    .attr('fill', params['header']['background']);
                this.svg.append('text')
                    .text(text)
                    .attr("font-size", params['header']['fontSize'])
                    .attr('fill', params['header']['color'])
                    .attr('x', params['global']['padding'][3] + offset[0])
                    .attr('y', params['global']['padding'][0] + offset[1])
                    .attr('dy', params['header']['backgroundRect'][1] + params['header']['padding'][0])
            },
            add_midline(seq, params){
                for (let i = 0; i < seq.length; i++) {
                    this.svg.append('rect')
                        .attr('width', params['aa']['backgroundRect'][0])
                        .attr('height', params['aa']['backgroundRect'][1])
                        .attr('x', params['global']['padding'][3] + params['aa']['backgroundPadding'][3] + params['aa']['fontSize'] * i)
                        .attr('y', params['header']['backgroundRect'][1] + params['global']['padding'][0] + params['aa']['backgroundPadding'][0])
                        .attr('text-anchor', 'middle')
                        .attr('fill', params['midline']['background']);
                    this.svg.append('text')
                        .text("|")
                        .attr('fill', params['midline']['color'])
                        .attr("font-size", params['aa']['fontSize'])
                        .attr('x', params['global']['padding'][3] + params['aa']['padding'][3] + params['aa']['fontSize'] * i)
                        .attr('y', params['header']['backgroundRect'][1] + params['global']['padding'][0] + params['aa']['padding'][0])
                        .attr('text-anchor', 'middle')
                        .attr('dx', params['aa']['offset'][0])
                        .attr('dy', params['aa']['offset'][1])
                }
            },
            add_aa(seq, params, offset, colors){
                for (let i = 0; i < seq.length; i++) {
                    let aa = seq[i];
                    // console.log(i, aa);
                    this.svg.append('rect')
                        .attr('width', params['aa']['backgroundRect'][0])
                        .attr('height', params['aa']['backgroundRect'][1])
                        .attr('x',offset[0] + params['global']['padding'][3] + params['aa']['backgroundPadding'][3] + params['aa']['fontSize'] * i)
                        .attr('y',offset[1] +  params['global']['padding'][0] + params['aa']['backgroundPadding'][0])
                        .attr('text-anchor', 'middle')
                        .attr('fill', colors[aa])
                         ;

                    this.svg.append('text')
                        .text(aa)
                        .attr('fill', params['aa']['color'])
                        .attr("font-size", params['aa']['fontSize'])
                        .attr('x', offset[0] +  params['global']['padding'][3] + params['aa']['padding'][3] + params['aa']['fontSize'] * i)
                        .attr('y', offset[1] +  params['global']['padding'][0] + params['aa']['padding'][0])
                        .attr('text-anchor', 'middle')
                        // .attr("dominant-baseline","middle")
                        .attr('dx', params['aa']['offset'][0])
                        .attr('dy', params['aa']['offset'][1])

                }
            },
            add_ruler(seq, params){
                let seq_len = seq.length;
                let y = params['global']['padding'][0] + params['global']['padding'][2] + params['header']['backgroundRect'][1]*3
                this.svg.append('line')
                    .attr('x1', params['global']['padding'][3] + params['header']['backgroundRect'][0])
                    .attr('y1', y)
                    .attr('x2', params['header']['backgroundRect'][0] + seq_len * params['aa']['backgroundRect'][0] + params['global']['padding'][3])
                    .attr('y2', y)
                    .attr('style', `stroke:${params['ruler']['color']};stroke-width:${params['ruler']['strokeWidth']}`);
                for (let i = 0; i < seq_len; i++) {
                    this.add_scale(i, params)
                }
            },
            add_scale(i, params){
                let y = params['global']['padding'][0] + params['global']['padding'][2] + params['header']['backgroundRect'][1]*3;
                let x = params['global']['padding'][3] + params['header']['backgroundRect'][0] + params['aa']['backgroundRect'][0]/2 + params['aa']['backgroundRect'][0]*i;
                let l_scale = 0;
                if((i+1)%params['scale']['interval'] === 0 || i === 0) {
                    l_scale = params['scale']['height'];
                    this.svg.append('text')
                        .text(i+1)
                        .attr('fill', params['scale']['color'])
                        .attr("font-size", params['scale']['fontSize'])
                        .attr('x', x)
                        .attr('y', y + params['scale']['height'] + 4)
                        .attr('text-anchor', 'middle')
                        // .attr("dominant-baseline","middle")
                        .attr('dx', params['scale']['offset'][0])
                        .attr('dy', params['scale']['offset'][1])
                }
                this.svg.append('line')
                    .attr('x1', x)
                    .attr('y1', y)
                    .attr('x2', x)
                    .attr('y2', y + params['scale']['height'] + l_scale)
                    .attr('style', `stroke:${params['ruler']['color']};stroke-width:${params['ruler']['strokeWidth']}`);

            }
        }
    }
    buildSeq
    function buildSeq(seqs, wrod_wrap) {
        if (wrod_wrap) {
            let seqs = wordWrap(seqs, wrod_wrap);
        }
        // let name_length = getMaxLength(seqs);
        // let seqs_count = Object.keys(seqs).length;
        // let l_padding = 5,
        //     // t_padding = 5,
        //     // b_padding = 5,
        //     // r_padding = 5,
        //     m_padding = 15,
        //     font_size = 18,
        // r_width = 18,
        // r_height = 22,
        // line_display = true,
        // char_length = name_length * (font_size / 2),
        // l_t_padding = l_padding + m_padding + char_length;
        // w = wrod_wrap * 18 + l_t_padding + r_padding,
        // h = t_padding + b_padding + seqs_count * 2 * r_height
        // if (!line_display) h = t_padding + b_padding + seqs_count * r_height
        // if (!wrod_wrap) w = seqs['Natural'].length * 18 + l_t_padding + r_padding
        var svg = d3.select("#seq_container")
            .append("svg")
            .attr('width', 500)
            .attr('height', 270)
            .attr("background", "red")
        svg
        // console.log("build_seq", svg)
        for (var k in seqs) {
            // addname(svg, k, j, name_length, 1)
            for (var i = 0; i < seqs[k].length; i++) {
                // if (k == "Natural") {
                // } else {
                // }
                // addAA(svg, seqs[k][i], i, j, 1, give_color);
            }
            // j += 1;
        }
    }

    // function addname(svg, name, j, name_length, line) {
    //     var temp_length = name_length - name.length,
    //         text_x = l_padding + temp_length * (9)
    //     if(line) rect_y = (j) * r_height * 2 + t_padding
    //     else rect_y = (j) * r_height + t_padding
    //     var text_y = rect_y + r_height / 2
    //     if(!line_display) {
    //
    //     }
    //     name = name.replace(RegExp("_", "g"), " ")
    //     var text = svg.append('text')
    //         .text(name)
    //         .attr('fill', "#333333")
    //         .attr('x', text_x)
    //         .attr('y', text_y)
    //         .attr('dy', '6')
    // }
    // function addAA(svg, aa, i, j, line, give_color) {
    //     var colors = {
    //         "A": "#f3a683",
    //         "R": "#f7d794",
    //         "N": "#778beb",
    //         "D": "#e77f67",
    //         "C": "#cf6a87",
    //         "Q": "#f19066",
    //         "E": "#f5cd79",
    //         "G": "#546de5",
    //         "H": "#e15f41",
    //         "I": "#c44569",
    //         "L": "#786fa6",
    //         "K": "#f8a5c2",
    //         "M": "#63cdda",
    //         "F": "#ea8685",
    //         "P": "#596275",
    //         "S": "#574b90",
    //         "T": "#f78fb3",
    //         "W": "#3dc1d3",
    //         "Y": "#e66767",
    //         "V": "#303952"
    //     }
    //     var rect_x = l_t_padding + i * r_width
    //     if(line) rect_y = (j) * r_height * 2 + t_padding
    //     else rect_y = (j) * r_height + t_padding
    //     var text_x = l_t_padding + i * r_width + r_width / 2,
    //         text_y = rect_y + r_height / 2,
    //         bk_color = "#1e1e1e00",
    //         tx_color = "#1e1e1e"
    //
    //     if (give_color) {
    //         bk_color = colors[aa]
    //         tx_color = "white"
    //     }
    //
    //     if (give_color) {
    //         svg.append('rect')
    //             .attr('width', r_width)
    //             .attr('height', r_height)
    //             .attr('x', rect_x)
    //             .attr('y', rect_y)
    //             .attr('fill', bk_color)
    //     }
    //     var text = svg.append('text')
    //         .text(aa)
    //         .attr('fill', tx_color)
    //         .attr('x', text_x)
    //         .attr('y', text_y)
    //         .attr('text-anchor', 'middle')
    //         //						  	.attr("dominant-baseline","middle")
    //         // .style('font-size', font_size)
    //         // .attr("font-family", "Consolas, Helvetica, Arial, sans-serif")
    //         .attr('dy', '6')
    //     //								svg.append("rect")
    //     //									.attr("height","26")
    //     //									.attr("width","18")
    //     //									.attr("y",bk_y)
    //     //									.attr("x",bk_x)
    //     //									.attr("fill",color)
    //     //				svg.append("text")
    //     //					.attr("y",text_y)
    //     //					.attr("x",text_x)
    //     //					.attr("fill","#ffffff")
    //     //					.attr("font-size","18")
    //     //					.attr("text-anchor","middle")
    //     //					.text(aa)
    //     //					.attr("font-weight","bold")
    //     //					.attr("stroke-width","#07cdf5")
    //     //					.attr("stroke","#00000070")
    //     //					.attr("font-family","Consolas, Helvetica, Arial, sans-serif")
    //     //					.attr("dominant-baseline","middle");
    // }

    // function addLine(svg, i, j) {
    //     var colors = {
    //         "A": "#f3a683",
    //         "R": "#f7d794",
    //         "N": "#778beb",
    //         "D": "#e77f67",
    //         "C": "#cf6a87",
    //         "Q": "#f19066",
    //         "E": "#f5cd79",
    //         "G": "#546de5",
    //         "H": "#e15f41",
    //         "I": "#c44569",
    //         "L": "#786fa6",
    //         "K": "#f8a5c2",
    //         "M": "#f3a683",
    //         "F": "#ea8685",
    //         "P": "#596275",
    //         "S": "#574b90",
    //         "T": "#f78fb3",
    //         "W": "#3dc1d3",
    //         "Y": "#e66767",
    //         "V": "#303952"
    //     }
    //     var font_size = '18px'
    //     rect_x = l_t_padding + i * r_width,
    //         rect_y = r_height + (j * r_height) * 2 + t_padding,
    //         text_x = l_t_padding + i * r_width + r_width / 2,
    //         text_y = rect_y + r_height / 2
    //
    //     //				var g = svg.append('g')
    //     //				var rect = g.append('rect')
    //     //							.attr('width',width)
    //     //							.attr('height',height)
    //     //							.attr('x', rect_x)
    //     //						  	.attr('y', rect_y)
    //     //						  	.attr('fill',"white")
    //     var text = svg.append('text')
    //         .text("|")
    //         .attr('fill', "#333333")
    //         .attr('x', text_x)
    //         .attr('y', text_y)
    //         .attr('text-anchor', 'middle')
    //         //						  	.attr("dominant-baseline","middle")
    //         .attr('dy', '5')
    // }
    function wordWrap(seqs, wrap_col) {
        let length = seqs[get_dict_first_key(seqs)].length + wrap_col;
        let start = 0,
            end = start + wrap_col,
            res_json = {};
        while (end < length) {
            for (let k in seqs) {
                // let name 修改过
                let name = k + addNull(start) + start
                res_json[name] = seqs[k].substring(start, end)
            }

            start = end
            if (end > length) {
                end = length
            } else {
                end = start + wrap_col
            }
        }
        return res_json
    }

    function addNull(num) {
        switch ((num + "").length) {
            case 1:
                return "___";
            case 2:
                return "__";
            case 3:
                return "_";

            default:
                break;
        }
    }

    function get_dict_first_key(dict) {
        for (let item in dict) {
            return item
        }
    }

    getMaxLength

    function getMaxLength(seqs) {
        let max = "";
        for (let k in seqs) {
            if (k.length > max.length) max = k;
        }
        return max.length
    }
</script>

<style scoped>
    .bm-none {
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .baimo-scrollbar {
        /*position: relative;*/
        /*display: block;*/
        /*width: 0;*/
        /*height: 0;*/
        /*cursor: pointer;*/
        /*border-radius: inherit;*/
        /*background-color: rgba(144,147,153,.3);*/
        /*transition: .3s background-color;*/
        overflow: auto !important;
        overflow-x: auto;
        overflow-y: auto;
    }

    .baimo-scrollbar ::-webkit-scrollbar-track-piece {
        background-color: #f8f8f8;
    }

    .baimo-scrollbar ::-webkit-scrollbar {
        width: 8px;
        height: 8px;
    }

    .baimo-scrollbar ::-webkit-scrollbar-thumb {
        background-color: rgba(144, 147, 153, .3);
        background-clip: padding-box;
        border-radius: 5px;
        transition: .3s background-color;
        min-height: 28px;
    }

    .baimo-scrollbar ::-webkit-scrollbar-thumb:hover {
        background-color: #bbb;
    }

    .topright-icon {
        float: right;
        left: 10px;
        top: 10px;
    }

    svg {
        background-color: blue;
    }
</style>
